import { Collection, Model } from 'web-mojo';

class AccessWindow extends Model {
    constructor(data = {}) {
        super(data, { endpoint: '/api/camaccess/access_window' });
    }

    statusLabel() {
        const labels = {
            pending: 'Pending',
            active: 'Active',
            expiring_soon: 'Expiring Soon',
            expired: 'Expired',
            revoked: 'Revoked',
        };
        return labels[this.get('status')] || this.get('status') || '—';
    }
}

class AccessWindowList extends Collection {
    constructor(options = {}) {
        super({
            ModelClass: AccessWindow,
            endpoint: '/api/camaccess/access_window',
            ...options,
        });
    }
}

export { AccessWindow, AccessWindowList };
